import { render } from "./SurveyEdit.vue?vue&type=template&id=2fe780e8"
import script from "./SurveyEdit.vue?vue&type=script&lang=js"
export * from "./SurveyEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__